export default {
  // Màn quản lý dữ liệu
  DataManagement: {
    DataManagement: 'Quản lý dữ liệu',
    HistoryDataManagement: 'Lịch sử quản lý dữ liệu',
    AddData: 'Thêm dữ liệu',
    CreatedDate: 'Ngày tạo:',
    CreatedBy: 'Người tạo',
    Working: 'ĐANG LÀM VIỆC',
    DataError: 'DỮ LIỆU LỖI',
    NotWorking: 'KHÔNG LÀM VIỆC',
    NotifyEmpty:
      'Đây là lần đầu tiên bạn làm việc với chương trình. <br />Vui lòng tạo dữ liệu kế toán mới để tiếp tục làm việc',
    BackupAndRestore: 'Sao lưu và phục hồi dữ liệu',
  },
  // Màn sao lưu
  BackupData: {
    NotiftyExprise:
      'Mỗi bản sao lưu chỉ được lưu trữ tối đa<span> 15 ngày</span>. Mỗi dữ liệu không quá<span> 3 bản.</span>',
    TitleConfirmDelete: 'Xóa dữ liệu sao lưu',
    MessageConfirmDelete:
      'Bạn đang thực hiện xóa bản sao lưu dữ liệu <span class="bold">{0}</span> ngày {1}. Bạn có chắc chắn muốn xóa không?',
    ActionGrid: {
      CancelBackup: 'Hủy sao lưu',
      Recover: 'Phục hồi',
    },
    TitleNotifyBackup: 'Dữ liệu đang phục hồi',
    MessageNotifyBackup:
      'Bạn không thể thực hiện Phục hồi bản sao lưu <span class="bold">{0}</span> cho đến khi nhận được thông báo hoàn thành quá trình phục hồi.',
    Cancel: 'Hủy',
  },
  // Popup phục hồi dữ liệu
  RestoreDataPopup: {
    Title: 'Phục hồi dữ liệu kế toán',
    NoteDescription:
      'Thời gian phục hồi phụ thuộc vào độ lớn dữ liệu. Vui lòng chờ đến khi nhận được thông báo từ hệ thống',
    BackupData: 'Dữ liệu sao lưu:',
    BackupTime: 'Thời gian sao lưu:',
    RestoreName: 'Tên dữ liệu sau phục hồi',
    Cancel: 'Hủy',
    Restore: 'Phục hồi',
  },
  HistoryDataManagement: {
    Period: 'Khoảng thời gian',
    From: 'Từ',
    To: 'Đến',
    GetData: 'Lấy dữ liệu',
  },
  // Popup đổi tên dữ liệu
  RenameData: {
    Title: 'Đổi tên dữ liệu',
    NameData: 'Tên dữ liệu',
    RenameSucess: 'Đổi tên dữ liệu thành công',
  },
  // Popup thay đổi nội dung kế toán
  AccountingDataInformation: {
    AccountingData: 'Dữ liệu kế toán',
    AccountingDataName: 'Tên DLKT:',
    AccountingDataNameTooltip: 'Tên dữ liệu kế toán',
    Version: 'Phiên bản:',
    AccountingInformation: 'Thông tin kế toán',
    AccountMode: 'Chế độ kế toán:',
    BookkeeppingMode: 'Chế độ ghi sổ',
    StartDate: 'Ngày bắt đầu:',
    CloseDate: 'Ngày khóa sổ:',
    IsUpdateCircular: 'Đã cập nhật TT-QĐ:',
    IsUpdateCircularTooltip: 'Đã cập nhật thông tư - quyết định',
    Special: 'Đặc thù:',
  },
  // Tạo dữ liệu kế toán
  CreateData: {
    TitleStep1: 'Khai báo thông tin dữ liệu',
    OrganizationName: 'Tên đơn vị',
    DataName: 'Tên dữ liệu *',
    AccountingMode: 'Chế độ kế toán',
    AccountingDate: 'Ngày hạch toán *',
    AccountingCurrency: 'Đồng tiền hạch toán',
    NoteStep1: 'Bạn chỉ nhập được số dư ban đầu tính đến trước {0} và hạch toán các nghiệp vụ phát sinh từ ngày này.',
    Cancel: 'Hủy bỏ',
    TitleStep2: 'Khai báo thông tin đơn vị',
    CreateAccountingData: 'Tạo dữ liệu kế toán',
    CreatingAccountingData: 'Đang tạo dữ liệu kế toán',
    One: '1',
    Two: '2',
    Three: '3',
    DeclareDataInformation: 'Khai báo thông tin dữ liệu',
    CompanyInfo: 'Thông tin đơn vị',
    CreateDatabase: 'Tạo dữ liệu kế toán',
    FirstMonthOfPeriod: 'Tháng đầu tiên của kỳ kế toán',
    OrganizationGrade: 'Cấp đơn vị',
    CompanyProvince: 'Tỉnh/Thành',
    CompanyDistrict: 'Quận/Huyện',
    PhoneNumber: 'Điện thoại',
    Fax: 'Fax',
    CreateSucess: 'Tạo mới dữ liệu thành công',
  },

  CreateDataPrevYear: {
    Description: 'Hệ thống sẽ tạo dữ liệu mới từ dữ liệu năm trước đã được chọn.',
    RetrieveBalanceAdjustDocument: 'Không lấy số dư đầu kỳ',
    Notify:
      'Chương trình đang thực hiện khởi tạo dữ liệu kế toán <span class="bold">{0}</span>. Theo dõi tiến trình tạo dữ liệu  tại <span class="bold">Quản lý dữ liệu.</span> Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.',
    NewDataName: 'Tên dữ liệu mới *',
    ChooseData: 'Chọn dữ liệu *',
    YearData: 'Dữ liệu năm {0}',
    AccountingSystem: 'Thông tư 70/2019/TT-BTC ngày 03/10/2019 của Bộ Tài chính',
    CreatingData: 'Đang tạo dữ liệu kế toán',
    CreatingDataInfo:
      'Chương trình đang thực hiện khởi tạo dữ liệu kế toán {0}. Theo dõi tiến trình tạo dữ liệu tại Quản lý dữ liệu. Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.',
  },

  // Tách dữ liệu theo Thông tư 107/2026/TT-BTC
  UpdateCircular: {
    MenuLabel: 'Cập nhật thông tư 107/2026/TT-BTC',
    Title: 'Cập nhật thông tư 107/2026/TT-BTC',
    Step1: 'Khai báo thông tin dữ liệu',
    Step2: 'Thực hiện',
    Step3: 'Kết quả',
    ChooseData: 'Chọn dữ liệu *',
    NewDataName: 'Tên dữ liệu mới *',
    FromDate: 'Ngày hạch toán *',
    FromDateMinError: 'Ngày không được nhỏ hơn {0}',
    CutoffDate: '01/10/2026',
    OrganizationName: 'Tên đơn vị',
    AccountingMode: 'Chế độ kế toán',
    AccountingModeValue: 'Thông tư 107/2026/TT-BTC hướng dẫn kế toán nghiệp vụ thi hành án dân sự',
    SourceDataName: 'Tên dữ liệu TT78 *',
    Currency: 'Đồng tiền hạch toán',
    Cancel: 'Hủy bỏ',
    NextStep: 'Tiếp tục',
    NoteStep1: 'Bạn chỉ nhập được số dư ban đầu tính đến trước ngày {0} và hạch toán các nghiệp vụ phát sinh từ ngày này',
    DuplicateNameTitle: 'Đổi tên dữ liệu',
    DuplicateNameBody: 'Tên dữ liệu đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
    Processing: 'Đang tách dữ liệu theo Thông tư 107/2026/TT-BTC',
    ProcessingTitle: 'Đang tạo dữ liệu kế toán',
    PleaseWait: 'Please Wait',
    ProcessingInfoPrefix: 'Chương trình đang thực hiện khởi tạo dữ liệu kế toán ',
    ProcessingInfoPlaceholder: '<<Tên dữ liệu kế toán theo TT107>>',
    ProcessingInfoMid: '. Theo dõi tiến trình tạo dữ liệu tại ',
    ProcessingInfoManageLink: 'Quản lý dữ liệu',
    ProcessingInfoSuffix: '. Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.',
    ProcessingInfo:
      'Chương trình đang thực hiện khởi tạo dữ liệu kế toán {0}. Theo dõi tiến trình tạo dữ liệu tại Quản lý dữ liệu. Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.',
    CreateSuccess: 'Tách dữ liệu theo Thông tư 107/2026/TT-BTC thành công',
    CreateFailed: 'Chương trình cập nhật Thông tư 107/2026/TT-BTC cho dữ liệu được chọn đã thất bại',
    Close: 'Đóng',
    ResultTitle: 'Kết quả tách dữ liệu',
    ResultFailTitle: 'Kết quả cập nhật Thông tư 107/2026/TT-BTC',
    ResultFailHeading: 'Chương trình cập nhật Thông tư 107/2026/TT-BTC cho dữ liệu được chọn đã thất bại',
    ResultFailDefaultMessage:
      'Đã có lỗi xảy ra trong quá trình tách dữ liệu. Vui lòng thử lại hoặc liên hệ MISA để được hỗ trợ.',
    ResultInfo:
      'Chương trình đã tách dữ liệu kế toán {0} theo Thông tư 107/2026/TT-BTC. Bạn có thể tải file Bảng cân đối phát sinh để so sánh số dư, và chọn dữ liệu để tiếp tục làm việc.',
    DownloadBalanceSheet: 'Tải file Bảng cân đối phát sinh',
    ChooseDataToContinue: 'Chọn dữ liệu để tiếp tục làm việc',
    BackToDataManagement: 'Về Quản lý dữ liệu',
    ResultHeading:
      'Chương trình đã hoàn thành cập nhật Thông tư 107/2026/TT-BTC cho dữ liệu được chọn gồm các nội dung sau',
    ResultBullet1: 'Cập nhật hệ thống tài khoản theo quy định tại Thông tư 107/2026/TT-BTC',
    ResultBullet4: 'Đáp ứng đầy đủ nghiệp vụ, báo cáo, sổ sách theo hướng dẫn của Thông tư 107/2026/TT-BTC',
    ResultBullet5: 'Chuyển đổi dữ liệu thành công, tải kết quả ',
    ResultBullet5Link: 'tại đây',
    ContinueOldBtn: 'Tại đây',
    ContinueNewBtn: 'Tại đây',
    OldDataPlaceholder: '<<Tên dữ liệu cũ>>',
    NewDataPlaceholder: '<<Tên dữ liệu mới>>',
    AccountNoMappingTitle: 'Chuyển đổi thất bại',
    AccountNoMappingBody:
      'Không thể tiếp tục chuyển đổi do dữ liệu có mở thêm tài khoản <b>{0}</b> ngang cấp với tài khoản trong danh mục hệ thống tài khoản quy định theo Thông tư 107/2026/TT-BTC. Xem hướng dẫn để thực hiện tách tài khoản, chuyển tài khoản hạch toán trước khi chuyển đổi dữ liệu {1}.',
    AccountNoMappingHelpLink: 'https://helppandaonline.misa.vn/kb/he-thong-tai-khoan/',
    AccountNoMappingHelpText: 'tại đây',
  },
  BackupAccountingDataPopup: {
    Title: 'Sao lưu dữ liệu kế toán',
    Backup: 'Sao lưu',
    CancelBackup: 'Hủy sao lưu',
    AccessDataAnother: 'Truy cập dữ liệu khác',
    Cancel: 'Hủy',
    BackupData: 'Dữ liệu cần sao lưu: ',
    NameDescription: 'Tên dữ liệu sao lưu',
    Note: 'CHÚ Ý:',
    NoteDescription:
      'Để đảm bảo tính đúng đắn của dữ liệu, bạn sẽ <span class="bold">không thể truy cập vào dữ liệu</span> trong quá trình sao lưu.',
    NotifyDescription: 'Hệ thống sẽ gửi thông báo đến email </br> <span class="link">{0}</span> sau khi hoàn thành.',
    SaveFiveYear: 'Lưu trữ 5 năm (Chỉ được lưu trữ 1 dữ liệu)',
    OverNumberBackupTitle: 'Vượt quá số lần sao lưu',
    OverNumberBackupBody:
      'Mỗi dữ liệu không được phép sao lưu quá {0} bản. Vui lòng xóa bớt bản sao lưu cũ để tiếp tục.',
    DelBackupFile: 'Xóa bản sao lưu',
    LoginToOtherDb: 'Truy cập vào dữ liệu khác',
    DuplicateTitle: 'Không hợp lệ',
    DuplicateBody: 'Tên dữ liệu sao lưu bị trùng với bản sao lưu khác. Vui lòng kiểm tra lại',
  },

  ConfirmDeletePopup: {
    Title: 'Cảnh báo xóa dữ liệu kế toán',
    Notify: 'Bạn đang thực hiện <span class="bold text-danger">xóa dữ liệu kế toán {0}</span>',
    Note: 'Chú ý: ',
    NoteDescription:
      'Dữ liệu đã xóa không thể truy cập và phục hồi lại được. Bạn chỉ nên sử dụng tính năng này khi chắc chắn dữ liệu đang chọn là không cần thiết và không có nhu cầu sử dụng lại sau này.',
    AcceptAllRight: 'Tôi đồng ý xóa và tự chịu trách nhiệm về các vấn đề phát sinh nếu có',
    RemoveData: 'Xóa dữ liệu',
  },
  ChangeDatabaseUsePopup: {
    Title: 'Chọn dữ liệu làm việc',
    Agree: 'Đồng ý',
    Cancel: 'Hủy bỏ',
  },
  RestoreAccountingDataPopup: {
    Title: 'Phục hồi dữ liệu kế toán',
    RestoreNote:
      'Thời gian phục hồi phụ thuộc vào độ lớn dữ liệu. Vui lòng chờ cho đến khi nhận được thông báo từ hệ thống',
    BackupDataTit: 'Dữ liệu sao lưu:',
    BackupTimeTit: 'Thời gian sao lưu:',
    RestoreNameTit: 'Tên dữ liệu sau phục hồi',
    Restore: 'Phục hồi',
    Cancel: 'Hủy bỏ',
  },

  TenantDatabasePopup: {
    TitleForm: 'Chọn dữ liệu kế toán',
    CurrentTenant: 'Đơn vị đang làm việc',
    OtherTenant: 'Chọn đơn vị khác',
    CurrentData: 'Dữ liệu',
    OtherData: 'Chọn dữ liệu khác',
    Save: 'Đồng ý',
    Cancel: 'Hủy',
  },
};
